// bao migrate skip
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import TabPage from "./../../factories/tab-page";
import BaoDialogViewModel from "./../../factories/bao-dialog";
import TreeNodeViewModel from "./../../factories/tree-node";
// bao migrate - module not found: import "services/bao-template-engine";
import "./../../bindings/bao-searcher";
import "./../../bindings/bao-toolbar2";
import "./../../bindings/sorting";
import "./../../bindings/bao-tree";
function RoleFolderStructureTabModel(tabPage, parent) {
    var self = this;
    self.Bao = Bao;
    self.Role = parent;
    self.CompleteCheck = function () {
        return true;
    };
    self.PageIndex = ko.observable(0);
    self.PageIndex.subscribe(function () {
        self.RefreshGrid();
    });
    self.PageSize = ko.observable(10);
    self.TotalRows = ko.observable(0);
    self.Sorting = ko.observableArray();
    self.Sorting.subscribe(function () {
        self.RefreshGrid();
    });
    self.FolderStructureCollection = ko.observableArray([]);
    var _deleteMessage = Bao.Session.GetMessage("msgDeleteRoleFolderStructure");
    self.toolbarClick = function (action) {
        switch (action.ActionKey()) {
            case "AddFolderStructureToRole":
                self.ShowRoleFolderStructureDialog(null);
                break;
            case "RemoveFolderStructureFromRole":
                if (self.SelectedFolderStructureRow() != null) {
                    var yesNoDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, _deleteMessage, "yesno");
                    yesNoDialog.DialogResult.subscribe(function (result) {
                        if (result === true) {
                            self.DeleteRoleFolderStructure(self.SelectedFolderStructureRow().FolderStructureRoleId);
                        }
                    });
                }
                break;
            case "EditRoleFolderStructure":
                if (self.SelectedFolderStructureRow() != null) {
                    self.ShowRoleFolderStructureDialog(self.SelectedFolderStructureRow());
                }
                break;
        }
    };
    self.RefreshGrid = function () {
        tabPage.IsLoading(true);
        return Bao.post("UadmCheckware/RoleFolderStructureTab/GetRoleFolderStructureCollection", JSON.stringify({
            sessionTabId: self.Role.TabPage.SessionTabId,
            roleId: self.Role.RoleId(),
            pageIndex: self.PageIndex(),
            pageSize: self.PageSize(),
            sorting: self.Sorting()
        }), function (searchResult) {
            tabPage.IsLoading(false);
            self.SelectedFolderStructureRow(null);
            self.TotalRows(0);
            self.FolderStructureCollection([]);
            if (searchResult != null && searchResult.Models != null) {
                self.FolderStructureCollection(searchResult.Models);
                self.TotalRows(searchResult.TotalRows);
            }
            self.ToggleToolbarButtons();
        });
    };
    var _msgCancel = Bao.Session.GetMessage("msgCancel");
    var _msgOk = Bao.Session.GetMessage("msgOk");
    self.AddRoleFolderStructure = function (model, roleId) {
        tabPage.IsLoading(true);
        return Bao.post("UadmCheckware/RoleFolderStructureTab/AddRoleFolderStructure", JSON.stringify({
            sessionTabId: self.Role.TabPage.SessionTabId,
            model: ko.map.toJS(model),
            roleId: roleId
        }), function () {
            self.Role.TabPage.DirtyFlag(true);
            self.RefreshGrid();
        });
    };
    self.DeleteRoleFolderStructure = function (folderStructureRoleId) {
        return Bao.post("UadmCheckware/RoleFolderStructureTab/DeleteRoleFolderStructure", JSON.stringify({
            sessionTabId: self.Role.TabPage.SessionTabId,
            folderStructureRoleId: folderStructureRoleId
        }), function () {
            self.Role.TabPage.DirtyFlag(true);
            self.RefreshGrid();
        });
    };
    self.ShowRoleFolderStructureDialog = function (roleFolderStructure) {
        return Bao.post("UadmCheckware/RoleFolderStructureTab/ShowRoleFolderStructureDialog", JSON.stringify({
            sessionTabId: self.Role.TabPage.SessionTabId,
            roleFolderStructureModel: roleFolderStructure
        }), function (value) {
            var dialogModel = ko.map.fromJS(value.Model);
            self.Dialog = new BaoDialogViewModel(Bao.Session.ApplicationName);
            self.Dialog.Width("500px");
            self.Dialog.Buttons([{
                Title: _msgOk,
                Click: function () {
                    var shouldReturn = false;
                    if (self.Dialog.ViewModel().IsRoleFolderStructureNew()) {
                        $.each(self.FolderStructureCollection(), function (index, item) {
                            if (item.FolderIdLevel1 == self.Dialog.ViewModel().FolderIdLevel1() && item.FolderIdLevel2 == self.Dialog.ViewModel().FolderIdLevel2() && item.FolderIdLevel3 == self.Dialog.ViewModel().FolderIdLevel3() && item.FolderIdLevel4 == self.Dialog.ViewModel().FolderIdLevel4() && item.FolderIdLevel5 == self.Dialog.ViewModel().FolderIdLevel5()) {
                                new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgRoleFolderStructureExists"), "info");
                                shouldReturn = true;
                            }
                        });
                    }
                    if (shouldReturn) {
                        return;
                    }
                    if (self.Dialog.ViewModel() != null && self.Dialog.ViewModel().FolderName() != null) {
                        self.Dialog.IsLoading(true);
                        self.AddRoleFolderStructure(self.Dialog.ViewModel(), self.Role.RoleId());
                        self.Dialog.Close();
                        self.Dialog.IsLoading(false);
                    }
                    else {
                        new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
                    }
                },
                Enabled: ko.observable(true)
            }, {
                Title: _msgCancel,
                Click: function () {
                    self.Dialog.Close();
                },
                Enabled: ko.observable(true)
            }]);
            self.Dialog.ViewModel(dialogModel);
            self.Dialog.ViewModel().SelectedFolderStructure = ko.observable();
            self.Dialog.ViewModel().DeleteFolder = function () {
                self.Dialog.ViewModel().CompleteFolderName("");
                self.Dialog.ViewModel().FolderIdLevel1(null);
                self.Dialog.ViewModel().FolderIdLevel2(null);
                self.Dialog.ViewModel().FolderIdLevel3(null);
                self.Dialog.ViewModel().FolderIdLevel4(null);
                self.Dialog.ViewModel().FolderIdLevel5(null);
                self.Dialog.ViewModel().FolderName("");
            };
            self.Dialog.ViewModel().OpenTreeDialog = function () {
                tabPage.IsLoading(true);
                Bao.post("Checkware/FolderStructure/ShowFolderStructureDialog", function (value) {
                    var dialog = new BaoDialogViewModel(Bao.Session.ApplicationName);
                    var dialogViewModel: any = {};
                    dialogViewModel.NodeToggled = function () {
                        dialog.SetPosition();
                    };
                    var dataSource = [];
                    for (var i = 0; i < value.nodes.length; i++) {
                        dataSource.push(new TreeNodeViewModel(value.nodes[i]));
                    }
                    dialogViewModel.Nodes = ko.observableArray(dataSource);
                    dialogViewModel.SelectedFolderStructure = ko.observable();
                    dialogViewModel.SelectedFolderStructure.subscribe(function () {
                        dialogViewModel.okClick();
                    });
                    dialogViewModel.okClick = function () {
                        tabPage.IsLoading(true);
                        var selectedNode;
                        selectedNode = dialogViewModel.SelectedFolderStructure();
                        if (selectedNode != null) {
                            Bao.post("Checkware/FolderStructure/Get", JSON.stringify({
                                folderStructureId: selectedNode.Key()
                            }), function (result) {
                                if (result != null) {
                                    self.Dialog.ViewModel().CompleteFolderName(result.CompleteFolderName);
                                    self.Dialog.ViewModel().FolderIdLevel1(result.FolderIdLevel1);
                                    self.Dialog.ViewModel().FolderIdLevel2(result.FolderIdLevel2);
                                    self.Dialog.ViewModel().FolderIdLevel3(result.FolderIdLevel3);
                                    self.Dialog.ViewModel().FolderIdLevel4(result.FolderIdLevel4);
                                    self.Dialog.ViewModel().FolderIdLevel5(result.FolderIdLevel5);
                                    self.Dialog.ViewModel().FolderName(result.FolderName);
                                }
                                dialog.Close();
                                tabPage.IsLoading(false);
                            });
                        }
                        else {
                            tabPage.IsLoading(false);
                        }
                    };
                    dialog.Width(500);
                    dialog.ViewModel(dialogViewModel);
                    dialog.Template(value.Message);
                    dialog.Buttons([{
                        Title: Bao.Session.GetMessage("msgOk"),
                        Enabled: ko.observable(true),
                        Click: dialogViewModel.okClick
                    }]);
                    dialog.Open();
                    tabPage.IsLoading(false);
                    dialog.SetPosition();
                });
            };
            self.Dialog.Template(value.Message);
            self.Dialog.Open();
        });
    };
    self.ToolbarButtons = ko.observableArray([]);
    self.ToolbarButtons.subscribe(function () {
        self.ToggleToolbarButtons();
    });
    self.SelectFolderStructureRow = function (item) {
        self.SelectedFolderStructureRow(item);
        return true;
    };
    self.SelectedFolderStructureRow = ko.observable({});
    self.SelectedFolderStructureRow.subscribe(function () {
        self.ToggleToolbarButtons();
    });
    self.ToggleToolbarButtons = function () {
        ko.utils.arrayForEach(self.ToolbarButtons(), function (button: any) {
            switch (button.ActionKey()) {
                case "RemoveFolderStructureFromRole":
                case "EditRoleFolderStructure":
                    button.Enabled(!(self.SelectedFolderStructureRow() == null));
                    break;
                case "AddFolderStructureToRole":
                    button.Enabled(!self.Role.IsNew());
                    break;
            }
        });
    };
    self.Refresh = function () {
        var def = $.Deferred();
        Bao.post("UadmCheckware/RoleFolderStructureTab/ResetRoleFolderStructure", JSON.stringify({
            sessionTabId: self.Role.TabPage.SessionTabId
        }), function () {
            self.RefreshGrid().then(function () {
                def.resolve();
            });
        });
        return def.promise();
    };
    self.Save = function () {
        return Bao.post("UadmCheckware/RoleFolderStructureTab/SaveRoleFolderStructureCollection", JSON.stringify({
            sessionTabId: self.Role.TabPage.SessionTabId,
            roleId: self.Role.RoleId(),
            saveTime: parent.SaveTime()
        }));
    };
    self.init = function () {
        return self.RefreshGrid();
    };
    self.loaded = function () {
        self.ToggleToolbarButtons();
    };
    self.Copy = function (roleId, saveTime) {
        return Bao.post("UadmCheckware/RoleFolderStructureTab/CopyRoleFolderStructureCollection", JSON.stringify({
            sessionTabId: self.Role.TabPage.SessionTabId,
            roleId: self.Role.RoleId(),
            newRoleId: roleId,
            saveTime: saveTime
        }));
    };
}
;
export default RoleFolderStructureTabModel;